// 导出状态 options
import { operateMaxShowLength } from '@/store/dict/config'

const taskStatusOptions = [
  { label: '进行中', value: 1 },
  { label: '成功', value: 3 },
  { label: '失败', value: 4 },
]
const taskTypeOptions = {
  1: '逾期明细表',
  2: '司机履约风控',
}
const config = function () {
  return {
    columns: [
      {
        name: 'gmtCreate',
        columnProps: {
          label: '导出时间',
          prop: 'gmtCreate',
          width: '220px',
        },
      },
      {
        name: 'userName',
        columnProps: {
          label: '操作人名称',
          prop: 'userName',
        },
      },
      {
        name: 'userAccount',
        columnProps: {
          label: '操作人账号',
          prop: 'userAccount',
        },
      },
      {
        name: 'taskStatus',
        columnProps: {
          label: '导出状态',
          prop: 'taskStatus',
          width: '80px',
        },
        render: ({ row }) => {
          const findItem = taskStatusOptions.find((item) => item.value === row.taskStatus)
          return this.$createElement('span', {}, (findItem && findItem.label) || '--')
        },
      },
      {
        name: 'operate',
        columnProps: {
          label: '导出详情',
        },
        maxShowLength: operateMaxShowLength,
        getOperateList: ({ row }) => {
          if (row.taskStatus === 4) {
            return '--'
          }
          return [
            { name: 'export', label: row.taskType ? taskTypeOptions[row.taskType] : taskTypeOptions[1], action: () => this.exportHandle(row) },
          ]
        },
        type: 'operate',
      },
    ],
    taskTypeOptions,
  }
}

export default config
